import React from 'react';
import { Box, Container, Typography, Divider, Stack } from '@mui/material';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.dark',
        color: 'common.white',
        mt: 6,
        pt: 5,
        pb: 4,
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 3, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          justifyContent="space-between"
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              component="img"
              src="/axillion-aerospace-logo.svg"
              alt="Axillon Aerospace"
              sx={{
                height: 32,
                filter: 'brightness(0) invert(1)',
              }}
            />
          </Box>

          <Typography
            variant="overline"
            sx={{ color: 'secondary.main' }}
          >
            Strength Through Innovation
          </Typography>
        </Stack>

        <Divider sx={{ my: 3, borderColor: 'divider' }} />

        <Typography
          variant="body2"
          sx={{
            color: 'rgba(255,255,255,0.55)',
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          &copy; {currentYear} Axillon Aerospace. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
